import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/material";
import { useFlags } from "launchdarkly-react-client-sdk";

import CustomTooltip from "components/common/Tooltip";
import { convertDate } from "components/Screens/CommonUtils";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import "./LeaveTypeCard.scss";

function LeaveTypeCard({ portal, style, leave, icon }) {
  const navigate = useNavigate();
  const { anniversaryBasedTimeOff, swappedLeavesRevamp } = useFlags();

  const { leaveType, taken, noOfLeaves, pending, scheduled, leaveTypeId, isFinite, endDate, encashments } = leave || {};

  const shouldShowLeaveCount = () => {
    if (leaveType === "Swapped" && swappedLeavesRevamp) return false;

    if (anniversaryBasedTimeOff) {
      return noOfLeaves > -1 && leaveType !== "Unpaid";
    }
    return noOfLeaves > -1 && isFinite;
  };

  return (
    <div
      className="leavetype-card-container"
      style={{
        ...style,
        background:
          "linear-gradient(221deg, #FFE0D7 4.69%, var(--color-primitives-primary-100) 41.39%, #D9F5EA 120.42%)",
      }}
    >
      <div className="leave-count-wrapper">
        <div className="leave-count-request-wrapper">
          <Stack direction="row" spacing="13px" alignItems="center">
            <div className="leave-count">
              <div className="leave-count-flex-row">
                <div className="leave-count-remaining" id="taken-leaves">
                  {taken}
                </div>

                {shouldShowLeaveCount() && (
                  <>
                    <div className="leave-count-total leave-count-total-slash" id="no-of-leaves-slash">
                      /
                    </div>
                    <div className="leave-count-total leave-count-total-number" id="no-of-leaves-number">
                      {noOfLeaves}
                    </div>
                  </>
                )}
              </div>
              <div className="leave-card-type" id="leave-type">
                {leaveType}
              </div>
            </div>

            {leaveType === "Swapped" ? icon : null}
          </Stack>

          {portal !== "admin" && (
            <div className="flex items-center gap-025">
              <div
                className="leave-request-btn"
                id={`request-leave-${leaveType}`}
                onClick={() => navigate(`/main/timeoff/request?leaveTypeId=${leaveTypeId}`)}
              >
                Request
              </div>
              {leaveType === "Annual" && encashments > 0 && (
                <CustomTooltip
                  content={`${encashments} day${encashments > 1 ? "s have" : " has"} been encashed for the current leave cycle (Ending on : ${convertDate(endDate)}) as per your agreement with HR. For any discrepancies, please contact the HR team.`}
                  arrow
                  placement="bottom"
                >
                  <InfoOutlinedIcon fontSize="small" color="action" />
                </CustomTooltip>
              )}
            </div>
          )}
        </div>
        {portal !== "admin" && pending + scheduled > 0 && (
          <div className="leave-count-scheduled">+{pending + scheduled} Scheduled/pending</div>
        )}
      </div>
    </div>
  );
}

export default LeaveTypeCard;
